// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2xbw1","tab":"ProcedureTabs_tab__2DkPu"};